import { gql } from '@guuru/graphql-common/gql';

export default gql(`#graphql
  mutation UpdateCommunityProfile(
    $expertId: ID!,
    $partnerId: ID!,
    $moments: MomentsInput!,
    $bio: String!
  ) {
    updateCommunityMoments(expertId: $expertId, partnerId: $partnerId, moments: $moments) {
      id
    }
    updatePartnerBio(expertId: $expertId, partnerId: $partnerId, bio: $bio) {
      id
    }
  }
`);
